import { useContext, useMemo } from "react";
import {
  BANK_FOR_BANK_CLIENT_GROUP,
  BANK_FOR_BANKS_USER_INN_CHAR,
  BANK_FOR_BANKS_USER_AUTHORITIES,
} from "../../../constants";
import { UserInterfaceAccessGuardContext } from "../../user-interface-access-guard-context";

export const useUserInterfaceAccessGuard = () => {
  const userInterfaceAccessGuardContext = useContext(
    UserInterfaceAccessGuardContext
  );

  if (userInterfaceAccessGuardContext === undefined) {
    throw new Error(
      "userInterfaceAccessGuardContext must be used within a UserInterfaceAccessGuardProvider"
    );
  }

  const { currentUserInfo, setCurrentUserInfo } =
    userInterfaceAccessGuardContext;

  const isBankForBanksUser = useMemo(
    () =>
      currentUserInfo.clientGroup === BANK_FOR_BANK_CLIENT_GROUP ||
      // Если ИНН клиента полностью состоит из нулей - клиент относится к категории "Банк для Банков"
      currentUserInfo.inn
        ?.split("")
        .every((char) => char === BANK_FOR_BANKS_USER_INN_CHAR) ||
      (!!currentUserInfo.userAuthority &&
        BANK_FOR_BANKS_USER_AUTHORITIES.includes(
          currentUserInfo.userAuthority
        )),
    [currentUserInfo]
  );

  return {
    currentUserInfo,
    isBankForBanksUser,
    setCurrentUserInfo,
  };
};
